import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var VisibleOutline = function VisibleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0083 19.7119C18.8232 19.7119 23.4053 14.2168 23.4053 12.5151C23.4053 10.8135 18.8066 5.32666 12.0083 5.32666C5.29297 5.32666 0.594727 10.8135 0.594727 12.5151C0.594727 14.2168 5.27637 19.7119 12.0083 19.7119ZM12.0083 18.085C6.7124 18.085 2.52051 13.6772 2.52051 12.5151C2.52051 11.5439 6.7124 6.95361 12.0083 6.95361C17.2793 6.95361 21.4795 11.5439 21.4795 12.5151C21.4795 13.6772 17.2793 18.085 12.0083 18.085ZM12.0083 16.9727C14.4819 16.9727 16.4658 14.939 16.4658 12.5151C16.4658 10.0332 14.4819 8.06592 12.0083 8.06592C9.51807 8.06592 7.52588 10.0332 7.53418 12.5151C7.55078 14.939 9.51807 16.9727 12.0083 16.9727ZM12 13.9512C11.2031 13.9512 10.5557 13.3037 10.5557 12.5151C10.5557 11.7266 11.2031 11.0791 12 11.0791C12.7969 11.0791 13.4443 11.7266 13.4443 12.5151C13.4443 13.3037 12.7969 13.9512 12 13.9512Z"
  })));
};

VisibleOutline.displayName = 'VisibleOutline';
export default VisibleOutline;